import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { ModelIntegrationCode } from '@/features/modelIntegrationCodes/types/modelIntegrationCode.type'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

interface UseModelIntegrationCodesProps<T> {
  filters?: {
    search?: string
    manufacturer_id?: string
    page?: number
  }
  mapper?: (data: any) => T
}

export const useModelIntegrationCodes = <T,>({
  filters: { search = '', manufacturer_id, page } = {},
  mapper = Mapper.default<T>(),
}: UseModelIntegrationCodesProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['modelIntegrationCodes', 'pending', search, manufacturer_id, page],
    queryFn: () =>
      privateAxios.get('/equipment_models/pending_integration', {
        params: {
          search: search || undefined,
          'q[manufacturer_id_eq]': manufacturer_id || undefined,
          page,
        },
      }),
    select: (response: { data: { data: ModelIntegrationCode[]; meta: MetaResponse } }) => ({
      data: mapper(response?.data?.data),
      meta: response?.data?.meta,
    }),
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
